import React, { memo, forwardRef } from "react";
const SvgTrippleBond = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M8 10a1 1 0 100 2h16a1 1 0 100-2H8zm-1 6a1 1 0 011-1h16a1 1 0 110 2H8a1 1 0 01-1-1zm0 5a1 1 0 011-1h16a1 1 0 110 2H8a1 1 0 01-1-1z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgTrippleBond.displayName = "SvgTrippleBond";
const MemoForwardRef = memo(SvgTrippleBond);
export default MemoForwardRef;
